import EmailValidationComponent from "@components/find/EmailValidationComponent";
import LabelWithInput from "@components/input/LabelWithInput";

const VerifyEmail = () => {
  return (
    <LabelWithInput label={"이메일"} required={true}>
      <EmailValidationComponent
        fieldName="login_id"
        modalMessage="입력하신 이메일로 링크가 전송되었습니다."
        subMessage="인증 후 회원가입을 완료해주세요."
        type="signup"
      />
    </LabelWithInput>
  );
};

export default VerifyEmail;
